import {connect} from 'react-redux';
import {NotebookSectionsList as Component} from './NotebookSectionsList';
import {setNoteBookSection} from '@learningblocks/protocol-redux/lib/Actions';

function mapStateToProps(state) {
  return {
    sections: state.notebook.sections,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    goToSection: (section) => {
      dispatch(setNoteBookSection(section));
    },
  };
}

export const NotebookSectionsList = connect(
  mapStateToProps,
  mapDispatchToProps
)(Component);
